<script setup>
import LocationBlock from "./reservations/LocationBlock.vue";
import LocationDialog from "./reservations/LocationDialog.vue";
import {ref} from "vue";
import { trans } from 'laravel-vue-i18n';
import {useConfirm} from "primevue/useconfirm";
import ConfirmPopup from "primevue/confirmpopup";
const model = defineModel()

const visibleDialog = ref(false);
const currentLocation = ref(null);
const currentLocationIndex = ref(null);
const action = ref(null);

const props = defineProps({
    form: Object
})

const newLocation = () => {
    action.value = 'new';
    currentLocation.value = {
        type: 'in_person',
        service: null,
        name: '',
        address: null,
        latitude: 50.087451,
        longitude: 14.420671
    }
    visibleDialog.value = true;
}

const editLocation = (location, id) => {
    action.value = 'edit';
    currentLocationIndex.value = id;
    currentLocation.value = JSON.parse(JSON.stringify(location));
    visibleDialog.value = true;
}

const confirm = useConfirm();
const removeLocation = (event, i) => {
    confirm.require({
        target: event.currentTarget,
        group: 'location-remove',
        message: trans('forms.confirm_remove_location'),
        icon: 'pi pi-exclamation-triangle',
        rejectProps: {
            label: trans('common.cancel'),
            severity: 'secondary',
            outlined: true
        },
        acceptProps: {
            label: trans('common.delete'),
            severity: 'danger'
        },
        accept: () => {
            model.value.splice(i, 1)
        }
    });
}
</script>

<template>
    <ConfirmPopup group="location-remove"></ConfirmPopup>
    <div>
        <transition-group name="list" tag="div" class="flex flex-col gap-3">
            <location-block v-for="(location, i) in model" @edit="editLocation(location, i)" @delete="(event) => removeLocation(event, i)" :key="location.id" :type="location.type" :name="location.name" :address="location.address" :coords="[location.latitude, location.longitude]" :service="location.service"></location-block>
        <div
            key="new"
            class="border border-dashed rounded border-gray-400 dark:border-gray-700 cursor-pointer transition-shadow hover:shadow-lg flex items-center justify-center flex-col gap-3 py-6"
            @click="newLocation"
        >
            <i class="pi pi-plus opacity-50" style="font-size: 2rem"></i>
            <p>{{ $t('forms.add_location_btn') }}</p>
        </div>
        </transition-group>
    </div>
    <LocationDialog v-if="currentLocation" :action="action" :index="currentLocationIndex" v-model="visibleDialog" :form="form" v-model:locations="model" v-model:current="currentLocation"></LocationDialog>
</template>

<style scoped lang="scss">
</style>
